import {find, isFunction, reject} from "lodash";
import {alphaCompare, numericCompare} from "../lib/Utils";
import {Select} from "antd";
import React, {useEffect, useState} from "react";
import {useModelSet} from "../model/modelHooks";

const {Option} = Select;

export default function AodSelector(
    {
        itemType,setName,
        ...props
    }) {
    const [list] = useModelSet(itemType, setName);
    return <ObjectSelector list={list} {...props} />;
}

// todo ? this caused recursive renders?
// Builds Selector from list of Objects returns Object (&label)
export function ObjectSelector(
    {
        list,
        keyName='id',
        label='name',
        sort='alpha',
        initialValue='',
        width= 300,
        onChange, onSelect,
        value,
        top,
        none,
        allowClear,
        ...props
    })
{
    //const [list] = useModelSet(itemType, setName);
    const [data, setData] = useState([]);

    function onEvent(id,onFunc,action) {
        console.log(`${action}: ${id}`);
        if (isFunction(onFunc)){
            if (none && id===0) {
                onFunc();
            } else {
                const item = find(list, i => i.id === id)
                onFunc(item, item[label]); // return object ~= to value passed in
            }
        }
    }

    //todo - ? useSort hook and/or build into useModel
    useEffect(()=> {
        const entries = list.map(item => ({id: item.id, label: item[label]}));
        const listTop = top ? find(entries, {id: top.id}): undefined;

        let sorted = listTop
            ? reject(entries, {id: top.id})
            : entries;

        if (sort) {
            const sortFunction = sort === 'alpha'
                ? alphaCompare
                : sort === 'numeric'
                    ? numericCompare
                    : i=>i ; // nop

            sorted = sorted.sort((a, b) =>
                sortFunction(a, b, 'label')
            );
        }
        if (listTop) {
            sorted.unshift(listTop);
        }
        if (none) {
            sorted.unshift({id:0, label:none});
        }

        setData(sorted);
    },[list, top, label, sort, none]);

    return (
    <Select
        showSearch
        style={{ width }}
        optionFilterProp="children"
        value={value ? value[label] : none }
        onChange={v=>onEvent(v,onChange,'changed')}
        onSelect={v=>onEvent(v,onSelect,'selected')}
        filterOption={(input, option) =>
            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
        allowClear={!none && allowClear}
        {...props}
    >
        {data.map(({id,label})=>
            <Option key={id} value={id}>{label}</Option>)}
    </Select>
    );
}